import Typography from '@mui/joy/Typography'
import Box from '@mui/joy/Box'
import { AddLayerDropdown } from './AddLayerDropdown'
import { canvasActions } from '../common/canvasActions'
import { LayerList } from './LayerList'
import staticImage from '../assets/static_default_img.png'
import dynamicImage from '../assets/dynamic_default_img.png'

export const AdminLayerManager = ({ canvas, layers, selected }) => {
    const staticActions = [
        {
            displayName: 'Rectangle',
            func: () => canvasActions.addRectangle(canvas),
        },
        {
            displayName: 'Triangle',
            func: () => canvasActions.addTriangle(canvas),
        },
        {
            displayName: 'Circle',
            func: () => canvasActions.addCircle(canvas),
        },
        {
            displayName: 'Image',
            func: () => canvasActions.addImage(staticImage, canvas),
        },
        {
            displayName: 'Text',
            func: () => canvasActions.addTextbox(canvas),
        },
    ]

    const dynamicActions = [
        {
            displayName: 'Text',
            func: () => canvasActions.addTemplateTextbox(canvas),
        },
        {
            displayName: 'Prompt Text',
            func: () => canvasActions.addPromptTextbox(canvas),
        },
        {
            displayName: 'Image',
            func: () => canvasActions.addTemplateImage(dynamicImage, canvas),
        },
    ]

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography color="neutral" level="h4">
                    Layers
                </Typography>
                <AddLayerDropdown
                    staticActions={staticActions}
                    dynamicActions={dynamicActions}
                />
            </Box>
            {layers.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <LayerList
                        layers={layers}
                        onChange={(layer, value) => layer.set('name', value)}
                        selected={selected}
                    />
                </Box>
            )}
        </Box>
    )
}
